<template>
  <modal
    :back="false"
    @close="$emit('close')"
  >
    <h4 slot="title">
      {{ !edit ? $t('addWorkplace') : $t('editWorkplace') }}
    </h4>
    <section slot="body">
      <!--<edit ref="name" title="Name" v-model="name" />-->
      <editable-input
        id="name-input-wrapper"
        :key="nameKey + 'name'"
        v-model="name"
        :title="$t('name')"
        :placeholder="$t('egOurOffice')"
        :incorrect-value-msg="infoMsg"
        :validation-function="checkWorkplaceName"
        auto-capitalize="on"
        @focus-next-input="save"
      />
      <dropdown
        v-model="locationType.name"
        :title="$t('type')"
        :options="locationTags()"
        @input="typeChanged"
      />
      <dropdown
        v-if="locationFixed"
        v-model="timezone"
        editable
        auto-complete
        :title="$t('timezone')"
        :options="timezones"
      />
      <ColorPicker
        :key="colorKey + 'color'"
        v-model="color"
        :title="$t('color')"
        :color-prop="color"
      />
    </section>
    <footer slot="footer">
      <button
        class="clavo-button"
        :class="{ inactive: !valid || clicked }"
        @click="save"
      >
        {{ !edit ? $t('add') : $t('save') }}
      </button>
    </footer>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import Dropdown from '@/components/UI/Dropdown'
import ColorPicker from '@/components/UI/ColorPicker'
import EditableInput from '@/components/UI/EditableInput'
import Constants from '@/components/Constants'
import Color from '@/components/Color'
import ParseFunctions from '@/components/ParseFunctions'
import { getNextLocationColor } from '../../../clavo-shared/functions/util'

export default {
  components: {
    Modal,
    Dropdown,
    ColorPicker,
    EditableInput,
  },
  mixins: [Constants, ParseFunctions, Color],
  props: {
    teamId: {
      type: String,
      default: '',
    },
    userId: {
      type: String,
      default: '',
    },
    alreadyUsedColors: {
      type: Array,
      default: () => [],
    },
    alreadyUsedWorkplaceNames: {
      type: Array,
      default: () => [],
    },
    location: {
      default: undefined,
      type: Object,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    colorProp: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      locationType: { name: '', value: '' },
      timezones: [],
      name: '',
      color: null,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locationFixed: true,
      nameKey: 0,
      colorKey: 0,
      clicked: false,
      infoMsg: '',
    }
  },
  computed: {
    valid() {
      return this.name !== '' && this.timezone !== '' && !this.alreadyUsedWorkplaceNames.includes(this.name)
    },
  },
  created() {
    this.color = this.colorProp || getNextLocationColor(Object.keys(this.colors), this.alreadyUsedColors)

    // console.log(this.location)
    const locationTags = this.locationTags()

    this.timezones = this.$store.state.timezonesGlobal
    if (this.location) {
      if (this.location.name) this.name = this.location.name
      if (this.location.color) this.color = this.location.color
      if (this.location.timezone) this.timezone = this.location.timezone
      if (this.location.type && this.location.type !== 'office') {
        this.locationFixed = false
        this.locationType = locationTags.find(x => x.value === this.location.type) || locationTags[1]
      } else {
        this.locationType = locationTags[0]
        this.locationFixed = true
      }
    } else {
      this.locationType = locationTags[0]
      this.locationFixed = true
    }
  },
  methods: {
    async save() {
      this.clicked = true
      let res

      if (!this.edit) {
        res = await this.addLocation(
          this.name,
          this.color,
          this.teamId,
          this.locationFixed,
          this.locationFixed ? this.timezone : undefined,
          this.locationType.value,
        )
      } else {
        res = await this.editLocation(
          this.location.objectId,
          this.name,
          this.color,
          this.locationFixed,
          this.locationFixed ? this.timezone : undefined,
          this.locationType.value,
        )
      }

      if (res.status === 'ok') {
        this.$emit('save')
        this.$emit('close')
      } else {
        this.showServerError(res)
        this.clicked = false
      }
    },
    typeChanged(value) {
      const locationTags = this.locationTags()
      let index = locationTags.findIndex(x => value === x.value) || 1

      this.locationFixed = value === 'office'
      this.locationType = locationTags[index]
      if (!this.edit) {
        this.nameKey++
        this.colorKey++
      }
    },
    checkWorkplaceName() {
      if (this.name == '') {
        this.infoMsg = this.$t('locationNameCannotBeEmpty')
        return false
      }
      if (this.alreadyUsedWorkplaceNames.includes(this.name)) {
        this.infoMsg = this.$t('locationNameAlreadyUsed')
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  margin-left: 20%;
  margin-right: 20%;

  > * {
    margin-top: 25px;
  }
}

/*  button.inactive {
      background-color: $soap;
      cursor: default;
  }*/
</style>
